import { differenceInDays } from 'date-fns'

export const daysUntil = (date) => {
  date.setHours(0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return differenceInDays(date, today)
}
